import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'

import clsx from 'clsx'
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Keyboard } from 'swiper'
import useResponsive from 'utils/useResponsive'

import Erigo from 'assets/image/testimoni/erigo.png'
import Halodoc from 'assets/image/testimoni/halodoc.png'
import Decathlon from 'assets/image/testimoni/decathlon.png'
import ManuvaRetail from 'assets/image/testimoni/manuva-retail.png'

import ErigoTablet from 'assets/image/testimoni/erigo-mobile.png'
import HalodocTablet from 'assets/image/testimoni/halodoc-mobile.png'
import DecathlonTablet from 'assets/image/testimoni/decathlon-mobile.png'
import ManuvaRetailTablet from 'assets/image/testimoni/manuva-retail-mobile.png'

const Testimoni = () => {
  const arrTestimoni = [
    {
      img: {
        desktop: Erigo,
        tablet: ErigoTablet
      },
      profile: {
        name: 'Hari Budiatsanoor',
        position: 'Operational Director of Erigo Store'
      },
      layanan: 'Super Merchant Fesyen dan Pakaian no.1 di Shopee dan Tokopedia',
      testimoni: '“Tjetak (Manuva) menjadi bagian penting dalam sistem pergudangan kami, dan bahkan seluruh rantai pasokan kami.”',
      wallet: {
        start: 5,
        current: 80
      }
    },
    {
      img: {
        desktop: Halodoc,
        tablet: HalodocTablet
      },
      profile: {
        name: 'Fariska Budi',
        position: 'Procurement Halodoc'
      },
      layanan: 'Teknologi Kesehatan no.1 di Indonesia',
      testimoni: '“Tjetak (Manuva) tidak pernah berkompromi dengan kualitas”',
      wallet: {
        start: 3,
        current: 30
      }
    },
    {
      img: {
        desktop: Decathlon,
        tablet: DecathlonTablet
      },
      profile: {
        name: 'Djamalludin',
        position: 'Supply Chain Manager of Indoin Group'
      },
      layanan: 'Retailer Produk Olahraga',
      testimoni: '“Berbeda dengan vendor lain, Tjetak (Manuva) membantu kami dalam seluruh proses pengembangan.”',
      wallet: {
        start: 3,
        current: 13
      }
    },
    {
      img: {
        desktop: ManuvaRetail,
        tablet: ManuvaRetailTablet
      },
      profile: {
        name: 'Toko Ziran Berkah',
        position: 'Retail Store'
      },
      layanan: 'Toko Kemasan Retail Besar dan Online Shop',
      testimoni: '“Harga terbaik, pengiriman baik, praktis cara pemesanan, yang kerennya punya aplikasi sendiri”.',
      wallet: {
        start: 40,
        current: 70
      }
    },
    {
      img: {
        desktop: ManuvaRetail,
        tablet: ManuvaRetailTablet
      },
      profile: {
        name: 'Toko CP Plastik',
        position: 'Wholesaler'
      },
      layanan: 'Toko Kemasan Grosir',
      testimoni: '“Dapat diandalkan, pengiriman tepat waktu, pembaruan tingkat stok cukup akurat di aplikasi, respon sales cukup bagus, overall puas dengan service-nya”',
      wallet: {
        start: 60,
        current: 70
      }
    },
    {
      img: {
        desktop: ManuvaRetail,
        tablet: ManuvaRetailTablet
      },
      profile: {
        name: 'Toko 91 Plastik',
        position: 'Retail Store'
      },
      layanan: 'Toko Kemasan Retail Besar dan Online Shop',
      testimoni: '“Tjetak (Manuva) memiliki pengiriman tercepat sejauh ini dan juga memiliki program menarik yang memicu keinginan kami untuk bersaing”.',
      wallet: {
        start: 40,
        current: 70
      }
    },

    {
      img: {
        desktop: Erigo,
        tablet: ErigoTablet
      },
      profile: {
        name: 'Hari Budiatsanoor',
        position: 'Operational Director of Erigo Store'
      },
      layanan: 'Super Merchant Fesyen dan Pakaian no.1 di Shopee dan Tokopedia',
      testimoni: '“Tjetak (Manuva) menjadi bagian penting dalam sistem pergudangan kami, dan bahkan seluruh rantai pasokan kami.”',
      wallet: {
        start: 5,
        current: 80
      }
    },
    {
      img: {
        desktop: Halodoc,
        tablet: HalodocTablet
      },
      profile: {
        name: 'Fariska Budi',
        position: 'Procurement Halodoc'
      },
      layanan: 'Teknologi Kesehatan no.1 di Indonesia',
      testimoni: '“Tjetak (Manuva) tidak pernah berkompromi dengan kualitas”',
      wallet: {
        start: 3,
        current: 30
      }
    },
    {
      img: {
        desktop: Decathlon,
        tablet: DecathlonTablet
      },
      profile: {
        name: 'Djamalludin',
        position: 'Supply Chain Manager of Indoin Group'
      },
      layanan: 'Retailer Produk Olahraga',
      testimoni: '“Berbeda dengan vendor lain, Tjetak (Manuva) membantu kami dalam seluruh proses pengembangan.”',
      wallet: {
        start: 3,
        current: 13
      }
    },
    {
      img: {
        desktop: ManuvaRetail,
        tablet: ManuvaRetailTablet
      },
      profile: {
        name: 'Toko Ziran Berkah',
        position: 'Retail Store'
      },
      layanan: 'Toko Kemasan Retail Besar dan Online Shop',
      testimoni: '“Harga terbaik, pengiriman baik, praktis cara pemesanan, yang kerennya punya aplikasi sendiri”.',
      wallet: {
        start: 40,
        current: 70
      }
    },
    {
      img: {
        desktop: ManuvaRetail,
        tablet: ManuvaRetailTablet
      },
      profile: {
        name: 'Toko CP Plastik',
        position: 'Wholesaler'
      },
      layanan: 'Toko Kemasan Grosir',
      testimoni: '“Dapat diandalkan, pengiriman tepat waktu, pembaruan tingkat stok cukup akurat di aplikasi, respon sales cukup bagus, overall puas dengan service-nya”',
      wallet: {
        start: 60,
        current: 70
      }
    },
    {
      img: {
        desktop: ManuvaRetail,
        tablet: ManuvaRetailTablet
      },
      profile: {
        name: 'Toko 91 Plastik',
        position: 'Retail Store'
      },
      layanan: 'Toko Kemasan Retail Besar dan Online Shop',
      testimoni: '“Tjetak (Manuva) memiliki pengiriman tercepat sejauh ini dan juga memiliki program menarik yang memicu keinginan kami untuk bersaing”.',
      wallet: {
        start: 40,
        current: 70
      }
    },

    {
      img: {
        desktop: Erigo,
        tablet: ErigoTablet
      },
      profile: {
        name: 'Hari Budiatsanoor',
        position: 'Operational Director of Erigo Store'
      },
      layanan: 'Super Merchant Fesyen dan Pakaian no.1 di Shopee dan Tokopedia',
      testimoni: '“Tjetak (Manuva) menjadi bagian penting dalam sistem pergudangan kami, dan bahkan seluruh rantai pasokan kami.”',
      wallet: {
        start: 5,
        current: 80
      }
    },
    {
      img: {
        desktop: Halodoc,
        tablet: HalodocTablet
      },
      profile: {
        name: 'Fariska Budi',
        position: 'Procurement Halodoc'
      },
      layanan: 'Teknologi Kesehatan no.1 di Indonesia',
      testimoni: '“Tjetak (Manuva) tidak pernah berkompromi dengan kualitas”',
      wallet: {
        start: 3,
        current: 30
      }
    },
    {
      img: {
        desktop: Decathlon,
        tablet: DecathlonTablet
      },
      profile: {
        name: 'Djamalludin',
        position: 'Supply Chain Manager of Indoin Group'
      },
      layanan: 'Retailer Produk Olahraga',
      testimoni: '“Berbeda dengan vendor lain, Tjetak (Manuva) membantu kami dalam seluruh proses pengembangan.”',
      wallet: {
        start: 3,
        current: 13
      }
    },
    {
      img: {
        desktop: ManuvaRetail,
        tablet: ManuvaRetailTablet
      },
      profile: {
        name: 'Toko Ziran Berkah',
        position: 'Retail Store'
      },
      layanan: 'Toko Kemasan Retail Besar dan Online Shop',
      testimoni: '“Harga terbaik, pengiriman baik, praktis cara pemesanan, yang kerennya punya aplikasi sendiri”.',
      wallet: {
        start: 40,
        current: 70
      }
    },
    {
      img: {
        desktop: ManuvaRetail,
        tablet: ManuvaRetailTablet
      },
      profile: {
        name: 'Toko CP Plastik',
        position: 'Wholesaler'
      },
      layanan: 'Toko Kemasan Grosir',
      testimoni: '“Dapat diandalkan, pengiriman tepat waktu, pembaruan tingkat stok cukup akurat di aplikasi, respon sales cukup bagus, overall puas dengan service-nya”',
      wallet: {
        start: 60,
        current: 70
      }
    },
    {
      img: {
        desktop: ManuvaRetail,
        tablet: ManuvaRetailTablet
      },
      profile: {
        name: 'Toko 91 Plastik',
        position: 'Retail Store'
      },
      layanan: 'Toko Kemasan Retail Besar dan Online Shop',
      testimoni: '“Tjetak (Manuva) memiliki pengiriman tercepat sejauh ini dan juga memiliki program menarik yang memicu keinginan kami untuk bersaing”.',
      wallet: {
        start: 40,
        current: 70
      }
    },

    {
      img: {
        desktop: Erigo,
        tablet: ErigoTablet
      },
      profile: {
        name: 'Hari Budiatsanoor',
        position: 'Operational Director of Erigo Store'
      },
      layanan: 'Super Merchant Fesyen dan Pakaian no.1 di Shopee dan Tokopedia',
      testimoni: '“Tjetak (Manuva) menjadi bagian penting dalam sistem pergudangan kami, dan bahkan seluruh rantai pasokan kami.”',
      wallet: {
        start: 5,
        current: 80
      }
    },
    {
      img: {
        desktop: Halodoc,
        tablet: HalodocTablet
      },
      profile: {
        name: 'Fariska Budi',
        position: 'Procurement Halodoc'
      },
      layanan: 'Teknologi Kesehatan no.1 di Indonesia',
      testimoni: '“Tjetak (Manuva) tidak pernah berkompromi dengan kualitas”',
      wallet: {
        start: 3,
        current: 30
      }
    },
    {
      img: {
        desktop: Decathlon,
        tablet: DecathlonTablet
      },
      profile: {
        name: 'Djamalludin',
        position: 'Supply Chain Manager of Indoin Group'
      },
      layanan: 'Retailer Produk Olahraga',
      testimoni: '“Berbeda dengan vendor lain, Tjetak (Manuva) membantu kami dalam seluruh proses pengembangan.”',
      wallet: {
        start: 3,
        current: 13
      }
    },
    {
      img: {
        desktop: ManuvaRetail,
        tablet: ManuvaRetailTablet
      },
      profile: {
        name: 'Toko Ziran Berkah',
        position: 'Retail Store'
      },
      layanan: 'Toko Kemasan Retail Besar dan Online Shop',
      testimoni: '“Harga terbaik, pengiriman baik, praktis cara pemesanan, yang kerennya punya aplikasi sendiri”.',
      wallet: {
        start: 40,
        current: 70
      }
    },
    {
      img: {
        desktop: ManuvaRetail,
        tablet: ManuvaRetailTablet
      },
      profile: {
        name: 'Toko CP Plastik',
        position: 'Wholesaler'
      },
      layanan: 'Toko Kemasan Grosir',
      testimoni: '“Dapat diandalkan, pengiriman tepat waktu, pembaruan tingkat stok cukup akurat di aplikasi, respon sales cukup bagus, overall puas dengan service-nya”',
      wallet: {
        start: 60,
        current: 70
      }
    },
    {
      img: {
        desktop: ManuvaRetail,
        tablet: ManuvaRetailTablet
      },
      profile: {
        name: 'Toko 91 Plastik',
        position: 'Retail Store'
      },
      layanan: 'Toko Kemasan Retail Besar dan Online Shop',
      testimoni: '“Tjetak (Manuva) memiliki pengiriman tercepat sejauh ini dan juga memiliki program menarik yang memicu keinginan kami untuk bersaing”.',
      wallet: {
        start: 40,
        current: 70
      }
    },

    {
      img: {
        desktop: Erigo,
        tablet: ErigoTablet
      },
      profile: {
        name: 'Hari Budiatsanoor',
        position: 'Operational Director of Erigo Store'
      },
      layanan: 'Super Merchant Fesyen dan Pakaian no.1 di Shopee dan Tokopedia',
      testimoni: '“Tjetak (Manuva) menjadi bagian penting dalam sistem pergudangan kami, dan bahkan seluruh rantai pasokan kami.”',
      wallet: {
        start: 5,
        current: 80
      }
    },
    {
      img: {
        desktop: Halodoc,
        tablet: HalodocTablet
      },
      profile: {
        name: 'Fariska Budi',
        position: 'Procurement Halodoc'
      },
      layanan: 'Teknologi Kesehatan no.1 di Indonesia',
      testimoni: '“Tjetak (Manuva) tidak pernah berkompromi dengan kualitas”',
      wallet: {
        start: 3,
        current: 30
      }
    },
    {
      img: {
        desktop: Decathlon,
        tablet: DecathlonTablet
      },
      profile: {
        name: 'Djamalludin',
        position: 'Supply Chain Manager of Indoin Group'
      },
      layanan: 'Retailer Produk Olahraga',
      testimoni: '“Berbeda dengan vendor lain, Tjetak (Manuva) membantu kami dalam seluruh proses pengembangan.”',
      wallet: {
        start: 3,
        current: 13
      }
    },
    {
      img: {
        desktop: ManuvaRetail,
        tablet: ManuvaRetailTablet
      },
      profile: {
        name: 'Toko Ziran Berkah',
        position: 'Retail Store'
      },
      layanan: 'Toko Kemasan Retail Besar dan Online Shop',
      testimoni: '“Harga terbaik, pengiriman baik, praktis cara pemesanan, yang kerennya punya aplikasi sendiri”.',
      wallet: {
        start: 40,
        current: 70
      }
    },
    {
      img: {
        desktop: ManuvaRetail,
        tablet: ManuvaRetailTablet
      },
      profile: {
        name: 'Toko CP Plastik',
        position: 'Wholesaler'
      },
      layanan: 'Toko Kemasan Grosir',
      testimoni: '“Dapat diandalkan, pengiriman tepat waktu, pembaruan tingkat stok cukup akurat di aplikasi, respon sales cukup bagus, overall puas dengan service-nya”',
      wallet: {
        start: 60,
        current: 70
      }
    },
    {
      img: {
        desktop: ManuvaRetail,
        tablet: ManuvaRetailTablet
      },
      profile: {
        name: 'Toko 91 Plastik',
        position: 'Retail Store'
      },
      layanan: 'Toko Kemasan Retail Besar dan Online Shop',
      testimoni: '“Tjetak (Manuva) memiliki pengiriman tercepat sejauh ini dan juga memiliki program menarik yang memicu keinginan kami untuk bersaing”.',
      wallet: {
        start: 40,
        current: 70
      }
    },

    {
      img: {
        desktop: Erigo,
        tablet: ErigoTablet
      },
      profile: {
        name: 'Hari Budiatsanoor',
        position: 'Operational Director of Erigo Store'
      },
      layanan: 'Super Merchant Fesyen dan Pakaian no.1 di Shopee dan Tokopedia',
      testimoni: '“Tjetak (Manuva) menjadi bagian penting dalam sistem pergudangan kami, dan bahkan seluruh rantai pasokan kami.”',
      wallet: {
        start: 5,
        current: 80
      }
    },
    {
      img: {
        desktop: Halodoc,
        tablet: HalodocTablet
      },
      profile: {
        name: 'Fariska Budi',
        position: 'Procurement Halodoc'
      },
      layanan: 'Teknologi Kesehatan no.1 di Indonesia',
      testimoni: '“Tjetak (Manuva) tidak pernah berkompromi dengan kualitas”',
      wallet: {
        start: 3,
        current: 30
      }
    },
    {
      img: {
        desktop: Decathlon,
        tablet: DecathlonTablet
      },
      profile: {
        name: 'Djamalludin',
        position: 'Supply Chain Manager of Indoin Group'
      },
      layanan: 'Retailer Produk Olahraga',
      testimoni: '“Berbeda dengan vendor lain, Tjetak (Manuva) membantu kami dalam seluruh proses pengembangan.”',
      wallet: {
        start: 3,
        current: 13
      }
    },
    {
      img: {
        desktop: ManuvaRetail,
        tablet: ManuvaRetailTablet
      },
      profile: {
        name: 'Toko Ziran Berkah',
        position: 'Retail Store'
      },
      layanan: 'Toko Kemasan Retail Besar dan Online Shop',
      testimoni: '“Harga terbaik, pengiriman baik, praktis cara pemesanan, yang kerennya punya aplikasi sendiri”.',
      wallet: {
        start: 40,
        current: 70
      }
    },
    {
      img: {
        desktop: ManuvaRetail,
        tablet: ManuvaRetailTablet
      },
      profile: {
        name: 'Toko CP Plastik',
        position: 'Wholesaler'
      },
      layanan: 'Toko Kemasan Grosir',
      testimoni: '“Dapat diandalkan, pengiriman tepat waktu, pembaruan tingkat stok cukup akurat di aplikasi, respon sales cukup bagus, overall puas dengan service-nya”',
      wallet: {
        start: 60,
        current: 70
      }
    },
    {
      img: {
        desktop: ManuvaRetail,
        tablet: ManuvaRetailTablet
      },
      profile: {
        name: 'Toko 91 Plastik',
        position: 'Retail Store'
      },
      layanan: 'Toko Kemasan Retail Besar dan Online Shop',
      testimoni: '“Tjetak (Manuva) memiliki pengiriman tercepat sejauh ini dan juga memiliki program menarik yang memicu keinginan kami untuk bersaing”.',
      wallet: {
        start: 40,
        current: 70
      }
    }
  ]

  const [activeIndex, setActiveIndex] = useState(15)
  const [nextNavTestimoniIsHover, setNextNavTestimoniHover] = useState(false)
  const [prevNavTestimoniIsHover, setPrevNavTestimoniHover] = useState(false)

  const { xl } = useResponsive()

  return (
    <section
      id="testimoni"
      className="bg-[#F7F8FA] pt-10 pb-20 lg:py-20 xl:py-[88px]"
    >
      <div className="flex justify-between items-center px-6 lg:px-14 xl:px-[120px]">
        <div className="w-fit m-auto lg:m-0 left-0 right-0">
          <h1 className="h4-bold xl:h3-bold text-center lg:text-left w-[196px] sm:w-full text-[#101838] m-auto left-0 right-0">
            What Our Customers Say
          </h1>
          <p className="text-m-reguler text-center lg:text-left w-[327px] sm:w-[439px] mt-2 lg:mt-4 xl:mt-6 text-[#969FB6]">
            We sell the highest quality of custom and ready made unbranded goods
            with the most competitive pricing, directly from our manufacturers!
          </p>
        </div>

        <div className="hidden lg:flex gap-x-4">
          <button
            className={clsx(
              'border border-neutral-50 rounded-[100%] p-3 prev-testimoni',
              'hover:bg-primary-main hover:border-primary-main'
            )}
            onMouseEnter={() => setPrevNavTestimoniHover(true)}
            onMouseLeave={() => setPrevNavTestimoniHover(false)}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.9998 19.9201L8.47984 13.4001C7.70984 12.6301 7.70984 11.3701 8.47984 10.6001L14.9998 4.08008"
                stroke={prevNavTestimoniIsHover ? 'white' : '#101838'}
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>

          <button
            className={clsx(
              'border border-neutral-50 rounded-[100%] p-3 next-testimoni',
              'hover:bg-primary-main hover:border-primary-main'
            )}
            onMouseEnter={() => setNextNavTestimoniHover(true)}
            onMouseLeave={() => setNextNavTestimoniHover(false)}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.91016 19.9201L15.4302 13.4001C16.2002 12.6301 16.2002 11.3701 15.4302 10.6001L8.91016 4.08008"
                stroke={nextNavTestimoniIsHover ? 'white' : '#101838'}
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>

      <div
        className={clsx(
          'relative mt-10 xl:mt-12 xl:mx-[-35%]',
          'pl-6 lg:pl-14 xl:pl-[0px]'

          // activeIndex === 48 ? 'pl-6 lg:pl-14 xl:pl-[120px]' : 'pl-[0px]',
          // activeIndex === 4 ? 'pr-6 lg:pr-14 xl:pr-[120px]' : 'pr-[0px]'
        )}
        style={
          {
            // marginLeft: '-35%',
            // marginRight: '-35%'
            // transitionProperty: 'all',
            // transitionDuration: '0.5s',
            // transitionTimingFunction: 'ease',
            // transitionDelay: '.79s'
          }
        }
      >
        <div
          className={clsx(
            'hidden xl:block absolute bg-[#F7F8FA] left-0 h-full z-[100]',
            activeIndex === 47 ? 'w-[25%]' : 'w-0'
          )}
          style={{
            transitionProperty: 'all',
            transitionDuration: '0.5s',
            transitionTimingFunction: 'ease'
          }}
        ></div>
        {/* relative inline-flex gap-x-8 mt-10 lg:mt-14 xl:mt-12 overflow-hidden */}
        <Swiper
          id="testimoni-swiper"
          className=""
          spaceBetween={32}
          slidesPerView="auto"
          onSlideChange={(swiper) => {
            setActiveIndex(swiper.activeIndex)
            console.log(swiper.activeIndex)
          }}
          onSwiper={(swiper) => {
            setActiveIndex(swiper.activeIndex)
            swiper.slideTo(0, 0)
            console.log(swiper.activeIndex)
          }}
          cssMode={true}
          navigation={{
            prevEl: '.prev-testimoni',
            nextEl: '.next-testimoni',
            clickable: true
          }}
          // navigation={true}
          mousewheel={false}
          keyboard={true}
          modules={[Navigation, Keyboard]}
          loop={true}
          breakpoints={{
            375: {
              initialSlide: 12
            },
            1280: {
              initialSlide: 11
            }
          }}
          // initialSlide={initSlide()}
          // speed={0}
        >
          {arrTestimoni.map((item, index) => {
            const { img, profile, layanan, testimoni } = item
            return (
              <SwiperSlide
                key={index}
                className="bg-white p-6 max-w-[327px] xl:max-w-[590px] flex flex-col xl:flex-row gap-x-6 rounded-xl min-h-[618px] xl:min-h-max"
              >
                <div className="w-[279px] h-[160px] xl:w-[196px] xl:h-[324px]">
                  <img src={xl ? img.desktop : img.tablet} alt="" />
                </div>

                <div className="xl:w-[322px] mt-6 xl:mt-0">
                  <div className="flex justify-between items-center">
                    <div className="flex gap-x-3 items-start">
                      <div className="w-12 h-12 p-3 bg-[#F7F8FA] rounded-[100%]">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
                            fill="#969FB6"
                          />
                          <path
                            d="M12.0002 14.5C6.99016 14.5 2.91016 17.86 2.91016 22C2.91016 22.28 3.13016 22.5 3.41016 22.5H20.5902C20.8702 22.5 21.0902 22.28 21.0902 22C21.0902 17.86 17.0102 14.5 12.0002 14.5Z"
                            fill="#969FB6"
                          />
                        </svg>
                      </div>

                      <div>
                        <h1 className="text-[#101838] font-bold leading-[150%] text-sm">
                          {profile.name}
                        </h1>
                        <p className="text-[#101838] font-normal leading-[150%] text-xs mt-[2px]">
                          {profile.position}
                        </p>
                      </div>
                    </div>

                    {/* <div className="hidden xl:flex gap-x-1">
                      <StarIcon />
                      <p className="text-s-medium text-primary-main">5.1</p>
                    </div> */}
                  </div>

                  <div className="flex xl:hidden gap-x-1 mt-6">
                    <StarIcon />
                    <StarIcon />
                    <StarIcon />
                    <StarIcon />
                    <StarIcon />
                  </div>

                  <div className="mt-4 xl:mt-6 pb-6">
                    <h1 className="text-neutral-100 text-l-bold">{layanan}</h1>
                    <p className="mt-4 text-neutral-100 text-s-reguler">
                      {testimoni}
                    </p>
                  </div>

                  {/* <div className="absolute bottom-6 flex gap-x-8 border-t border-t-neutral-30 pt-6">
                    <div>
                      <h1 className="text-xs-reguler xl:text-s-reguler text-neutral-40">
                        Starting Wallet Share
                      </h1>
                      <p className="h4-bold text-primary-main mt-1">{`${wallet.start}%`}</p>
                    </div>
                    <div>
                      <h1 className="text-xs-reguler xl:text-s-reguler text-neutral-40">
                        Current Wallet Share
                      </h1>
                      <p className="h4-bold text-primary-main mt-1">{`${wallet.current}%`}</p>
                    </div>
                  </div> */}
                </div>
              </SwiperSlide>
            )
          })}
        </Swiper>
      </div>
    </section>
  )
}

const StarIcon = ({ className }) => {
  return (
    <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.04917 3.92731C9.34852 3.006 10.6519 3.006 10.9513 3.92731L12.0209 7.21911C12.1547 7.63113 12.5387 7.91009 12.9719 7.91009H16.4331C17.4018 7.91009 17.8046 9.14971 17.0209 9.71911L14.2207 11.7535C13.8702 12.0082 13.7236 12.4596 13.8575 12.8716L14.927 16.1634C15.2264 17.0847 14.1719 17.8508 13.3882 17.2814L10.588 15.247C10.2375 14.9923 9.76293 14.9923 9.41244 15.247L6.61227 17.2814C5.82856 17.8508 4.77408 17.0847 5.07343 16.1634L6.143 12.8716C6.27688 12.4596 6.13022 12.0082 5.77973 11.7535L2.97956 9.71911C2.19585 9.14971 2.59862 7.91009 3.56735 7.91009H7.02855C7.46177 7.91009 7.84573 7.63113 7.9796 7.21911L9.04917 3.92731Z" fill="#FFB946"/>
    </svg>
  )
}

StarIcon.propTypes = {
  className: PropTypes.string
}

export default Testimoni
